import {Row, Col} from 'antd';
import {format} from 'date-fns';
import {useEffect, useState} from 'react';
import {LAUNCH_DATE} from 'src/constants';
import styles from './LaunchCountdown.module.scss';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export default function LaunchCountdown() {
  const [now, setNow] = useState<number>(Date.now());
  const duration = LAUNCH_DATE.getTime() - now;

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (duration <= 0) {
      window.location.reload();
    }
  }, [duration]);

  const days = Math.floor(duration / DAY);
  const hours = Math.floor((duration % DAY) / HOUR);
  const minutes = Math.floor((duration % HOUR) / MINUTE);
  const seconds = Math.floor((duration % MINUTE) / SECOND);

  if (duration <= 0) {
    return <div className={styles.letsgo}>🎉</div>;
  }

  return (
    <Row>
      <Col span={24}>
        <div className={styles.container}>
          Minting Starts on
          <br />
          <strong>
            {format(LAUNCH_DATE, 'PPPPp')}{' '}
            {LAUNCH_DATE.toLocaleString('en', {timeZoneName: 'short'}).split(' ').pop()}
          </strong>
          <div className={styles.countdown}>
            <div className={styles.unit}>
              <span>{days}</span> days
            </div>
            <div className={styles.unit}>
              <span>{hours}</span> hours
            </div>
            <div className={styles.unit}>
              <span>{minutes}</span> minutes
            </div>
            <div className={styles.unit}>
              <span>{seconds}</span> seconds
            </div>
          </div>
          <div className={styles.info}>
            Check out <a href='https://lisamona.xyz'>Lisa Mona</a> for more info
          </div>
        </div>
      </Col>
    </Row>
  );
}
